import { useTranslations } from "../../../contexts/Translation";
import { useEffect, useState } from "react";
import { useApiData } from "../../../contexts/ApiData";
import { EmailLang, Responder } from "../../../types";
import { H3 } from "../../Headers/Headings";
import { useSurvey } from "../../../contexts/Survey";
import { Tip } from "../../Tip/Index";
import AnonymousInvites from "./AnonymousInvites";
import ResponderList from "./ResponderList";
import SendInvitations from "./SendInvitations";
import styles from "./Invites.module.css";

type InvitesProps = {
  surveyId?: string;
  onInvitesUpdated?: (emails: EmailLang[]) => void; // Added prop
  displayInvitationText?: boolean;
  displayTip?: boolean;
  initialEmails?: EmailLang[];
  asForm?: boolean;
};

const Invites = ({ surveyId, onInvitesUpdated, initialEmails = [], displayInvitationText = true, displayTip = true, asForm = true }: InvitesProps) => {
  const t = useTranslations("invites");
  const { survey } = useSurvey();
  const { get } = useApiData();
  const [responders, setResponders] = useState<Responder[]>([]);

  useEffect(() => {
    const call = async () => {
      if (surveyId) {
        // Ensure surveyId is defined
        try {
          const responderList = await get(`/response/${surveyId}/responders`);
          setResponders(responderList);
        } catch (error) {
          console.error("Failed to fetch responders:", error);
          // Optionally, handle error state here
        }
      }
    };
    call();
  }, [get, surveyId]);

  const addResponders = (newResponders: Responder[]) => {
    setResponders((prevResponders) => [...prevResponders, ...newResponders]);
  };

  return (
    <div className={styles.container}>
      {!!survey?.allowAnonymous && <AnonymousInvites />}
      {displayTip && <Tip>{t("invitesInfo")}</Tip>}
      {surveyId && <ResponderList responders={responders} surveyId={surveyId} />}
      <SendInvitations
        asForm={asForm}
        addResponders={addResponders}
        responders={responders}
        initialEmails={initialEmails}
        onInvitesUpdated={onInvitesUpdated}
      />
      {displayInvitationText && (
        <>
          <H3>{t("invitationTextHeading")}</H3>
          <p className={styles.invitationText}>{survey?.invitationText || "No invitation text available."}</p>
        </>
      )}
    </div>
  );
};

export default Invites;
